// Measurement Fields Validation
console.log('=== Measurement Validation Loaded ===');

function validateMeasurements() {
  const form = document.querySelector('form[action*="/cart/add"]');
  
  if (!form) {
    console.log('Form not found');
    return;
  }
  
  console.log('Form found');
  
  const requiredFields = [
    { name: 'properties[Sleeve]', label: 'Sleeve' },
    { name: 'properties[Width]', label: 'Width' },
    { name: 'properties[Cuff]', label: 'Cuff' },
    { name: 'properties[Shoulder]', label: 'Shoulder' },
    { name: 'properties[Armhole]', label: 'Armhole' },
    { name: 'properties[Waist]', label: 'Waist' }
  ];
  
  function checkFields(event) {
    console.log('Validating fields...');
    
    let missing = [];
    
    requiredFields.forEach(field => {
      const input = form.querySelector(`[name="${field.name}"]`);
      if (input) {
        const val = input.value;
        console.log(field.label + ':', val);
        
        if (!val || val === '' || val === 'select' || val === 'Please select') {
          missing.push(field.label);
          input.style.border = '3px solid #ff0000';
          input.style.boxShadow = '0 0 10px rgba(255,0,0,0.5)';
        } else {
          input.style.border = '';
          input.style.boxShadow = '';
        }
      }
    });
    
    if (missing.length > 0) {
      console.log('BLOCKED! Missing:', missing);
      
      event.preventDefault();
      event.stopImmediatePropagation();
      
      alert('⚠️ Please select all measurements:\n' + missing.join(', ') + '\n\nالرجاء اختيار جميع القياسات:\n' + missing.join(', '));
      
      return false;
    }
    
    console.log('Validation passed');
    return true;
  }
  
  // Prevent form submission
  form.addEventListener('submit', checkFields, true);
  
  // Prevent add to cart button
  const submitBtn = form.querySelector('button[type="submit"]');
  if (submitBtn) {
    console.log('Submit button found');
    submitBtn.addEventListener('click', checkFields, true);
  }
  
  // Remove red border on change
  requiredFields.forEach(field => {
    const input = form.querySelector(`[name="${field.name}"]`);
    if (input) {
      input.addEventListener('change', function() {
        if (this.value && this.value !== 'select' && this.value !== 'Please select') {
          this.style.border = '';
          this.style.boxShadow = '';
        }
      });
    }
  });
  
  console.log('Validation initialized');
}

// Run validation
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', validateMeasurements);
} else {
  validateMeasurements();
}

window.addEventListener('load', validateMeasurements);